const styles = (theme) => ({
  mainWrapper: {
    padding: '34px 0',
    '@media(max-width: 767px)': {
      padding: '24px 0',
    },
  },
  titleWrapper: {
    marginBottom: 40,
    '@media(max-width: 767px)': {
      marginBottom: 20,
    },
  },
  title: {
    color: theme.palette.common.blue400,
    fontSize: theme.typography.fontSize32,
    fontWeight: theme.typography.fontWeightBold,
    lineHeight: 1,
    '@media(max-width: 767px)': {
      fontSize: theme.typography.fontSize20,
    },
  },
  cardWrapper: {
    padding: '16px 32px 32px',
    boxShadow: '0px 2px 8px rgb(0 0 0 / 5%)',
    borderRadius: 8,
    maxWidth: 830,
    '@media(max-width: 767px)': {
      padding: 0,
      boxShadow: 'none',
      borderRadius: 0,
      backgroundColor: 'transparent',
    },
  },
  accordianTitleWrapper: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
  },
  accordianTitle: {
    color: theme.palette.common.blue400,
    fontSize: theme.typography.fontSize18,
    lineHeight: '1.2',
    textAlign: 'left',
    '@media(max-width: 767px)': {
      fontSize: theme.typography.fontSize16,
    },
  },
  expandIcon: {
    color: theme.palette.common.blue400,
    marginRight: 24,
    '@media(max-width: 767px)': {
      marginRight: 18,
    },
  },
  divider: {
    backgroundColor: theme.palette.common.grey20,
  },
  accordianContentWrapper: {
    padding: '0 24px 24px 24px',
    marginTop: -20,
    '@media(max-width: 767px)': {
      padding: '0 18px 18px 18px',
      marginTop: -10,
    },
  },
  accordianContent: {
    color: theme.palette.text.primary,
    fontSize: theme.typography.fontSize16,
    lineHeight: '1.5',
    '@media(max-width: 767px)': {
      fontSize: theme.typography.fontSize14,
    },
    '& p': {
      margin: 0,
      marginBottom: '1em',
      '&:last-child': {
        marginBottom: 0,
      },
    },
    '& ul, & ol': {
      paddingLeft: '2em',
    },
  },
});

export default styles;
